import type { SchemaOf } from '../../helpers';
import { Joi, makeAllRequired } from '../../helpers';

export interface IConfig {
  activeListeningPollPeriodMS: number;
  activeListeningThreshold: number;
}

export const schemaMap: SchemaOf<IConfig> = {
  activeListeningPollPeriodMS: Joi.number(),
  activeListeningThreshold: Joi.number(),
};

export const schemaMapDefault = makeAllRequired(schemaMap);

export const defaultConfig: IConfig = {
  activeListeningPollPeriodMS: 200,
  activeListeningThreshold: 70,
};
